import { cn } from "@repo/utils/cn";
import { ComponentProps } from "react";

export type ImageOverlayProps = {
  color:
    | "black"
    | "white"
    | "brand-100"
    | "brand-500"
    | "brand-800"
    | "brand-900";
  blendMode?: "softLight" | "screen" | "multiply";
  opacity: number;
} & ComponentProps<"span">;

export function ImageOverlay({
  color,
  blendMode,
  opacity,
  className,
  ...props
}: ImageOverlayProps) {
  const colorMap = {
    black: "ui:bg-neutral-black",
    white: "ui:bg-neutral-white",
    "brand-100": "ui:bg-brand-100",
    "brand-500": "ui:bg-brand-500",
    "brand-800": "ui:bg-brand-800",
    "brand-900": "ui:bg-brand-900",
  };
  const blendModeMap = {
    softLight: "ui:mix-blend-soft-light",
    screen: "ui:mix-blend-screen",
    multiply: "ui:mix-blend-multiply",
  };

  return (
    <span
      {...props}
      className={cn(
        "ui:absolute ui:inset-0",
        colorMap[color],
        blendMode && blendModeMap[blendMode],
        className,
      )}
      style={{
        opacity: opacity / 100,
      }}
    />
  );
}
